<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_13289_179238)">
<path d="M6.5157 1.8027L7.30847 1.01855C7.64415 0.686524 8.18694 0.686524 8.51905 1.01855L15.4611 7.88165C15.7968 8.21367 15.7968 8.75057 15.4611 9.07907L8.51905 15.9457C8.18337 16.2777 7.64058 16.2777 7.30847 15.9457L6.5157 15.1615C6.17646 14.826 6.1836 14.2785 6.52999 13.95L10.8331 9.89501L0.569938 9.89501C0.0949908 9.89501 -0.287109 9.51706 -0.287109 9.04728L-0.287109 7.91697C-0.287109 7.44718 0.0949908 7.06924 0.569938 7.06924L10.8331 7.06924L6.52999 3.01425C6.18003 2.68576 6.17288 2.13826 6.5157 1.8027Z" fill="#009AFF"/>
</g>
<defs>
<clipPath id="clip0_13289_179238">
<rect width="16" height="16" fill="white" transform="translate(0 0.482422)"/>
</clipPath>
</defs>
</svg>
